import TheaterContainer from './TheaterContainer';

export default TheaterContainer;
